// actions/Gebinde.js
//
// DEPRECATION NOTICE:
// For product-related gebinde operations, prefer using updateProdukt() with
// gebinde_operations parameter instead of these direct actions.
// This ensures atomic updates and proper version history tracking.
// See: PATCH @produkte/{id} with gebinde_operations: { create, update, delete }

import {
  GET_GEBINDEBYID,
  CREATE_GEBINDE,
  UPDATE_GEBINDE,
  DELETE_GEBINDE,
} from '../../constants/ActionTypes';

// id = gebinde_id
export function getGebindeByID(id) {
  return {
    type: GET_GEBINDEBYID,
    request: {
      op: 'get',
      path: `/@gebinde/${id}`,
    },
  };
}

/**
 * @deprecated Use updateProdukt() with gebinde_operations.create instead.
 * This ensures atomic updates and proper version history tracking.
 */
export function createGebinde(formData) {
  return {
    type: CREATE_GEBINDE,
    request: {
      op: 'post',
      path: '/@gebinde',
      data: formData,
    },
  };
}

/**
 * @deprecated Use updateProdukt() with gebinde_operations.update instead.
 * This ensures atomic updates and proper version history tracking.
 */
export function updateGebinde(id, formData) {
  return {
    type: UPDATE_GEBINDE,
    request: {
      op: 'patch',
      path: `/@gebinde/${id}`,
      data: formData,
    },
  };
}

/**
 * @deprecated Use updateProdukt() with gebinde_operations.delete instead.
 * This ensures atomic updates and proper version history tracking.
 */
export function deleteGebinde(id) {
  return {
    type: DELETE_GEBINDE,
    request: {
      op: 'del',
      path: `/@gebinde/${id}`,
    },
  };
}
